var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 35,
    viewBox: "0 0 47 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_73_304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H47V11.6667H0V0Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.6667H47V23.3333H0V11.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23.3333H47V35H0V23.3333Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22.1666C26.0958 22.1666 28.2 20.0773 28.2 17.5C28.2 14.9227 26.0958 12.8333 23.5 12.8333C20.9043 12.8333 18.8 14.9227 18.8 17.5C18.8 20.0773 20.9043 22.1666 23.5 22.1666Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21.5833C25.7712 21.5833 27.6125 19.7552 27.6125 17.5C27.6125 15.2448 25.7712 13.4167 23.5 13.4167C21.2287 13.4167 19.3875 15.2448 19.3875 17.5C19.3875 19.7552 21.2287 21.5833 23.5 21.5833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18.3167C23.9542 18.3167 24.3225 17.951 24.3225 17.5C24.3225 17.049 23.9542 16.6833 23.5 16.6833C23.0457 16.6833 22.6775 17.049 22.6775 17.5C22.6775 17.951 23.0457 18.3167 23.5 18.3167Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5505 18.235C27.6631 18.2497 27.7664 18.1711 27.7812 18.0595C27.796 17.9478 27.7167 17.8453 27.6041 17.8306C27.4915 17.8159 27.3883 17.8945 27.3735 18.0062C27.3586 18.1178 27.4379 18.2203 27.5505 18.235Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21.5834L23.641 19.1334L23.5 17.9667L23.359 19.1334L23.5 21.5834Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.216 19.2476C27.3183 19.2931 27.4387 19.2472 27.4848 19.1452C27.531 19.0432 27.4854 18.9236 27.3831 18.8782C27.2807 18.8327 27.1603 18.8786 27.1142 18.9806C27.068 19.0826 27.1136 19.2022 27.216 19.2476Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4314 21.4429L23.2077 19.1157L23.3826 17.9521L22.9438 19.0406L22.4314 21.4429Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6356 20.1469C26.7248 20.2163 26.854 20.2005 26.9242 20.1117C26.9944 20.0228 26.979 19.8945 26.8898 19.8252C26.8007 19.7558 26.6715 19.7715 26.6013 19.8604C26.5311 19.9492 26.5465 20.0775 26.6356 20.1469Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.443 21.0363L22.7991 18.9844L23.2659 17.9041L22.5566 18.8445L21.443 21.0363Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8378 20.8624C25.9057 20.9529 26.0349 20.9714 26.1264 20.9037C26.2178 20.8359 26.2369 20.7077 26.169 20.6172C26.1011 20.5266 25.9719 20.5082 25.8804 20.5759C25.789 20.6436 25.7699 20.7719 25.8378 20.8624Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5895 20.3854L22.4349 18.7565L23.1701 17.8319L22.2404 18.5547L20.5895 20.3854Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8842 21.3514C24.9281 21.4554 25.0485 21.5046 25.1531 21.4612C25.2577 21.4178 25.307 21.2982 25.2631 21.1942C25.2193 21.0901 25.0989 21.041 24.9942 21.0844C24.8896 21.1278 24.8403 21.2473 24.8842 21.3514Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9388 19.5417L22.1461 18.4378L23.0926 17.7333L22.0044 18.1954L19.9388 19.5417Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8313 21.5736C23.8455 21.6864 23.9489 21.7666 24.0623 21.7528C24.1756 21.739 24.256 21.6364 24.2418 21.5236C24.2276 21.4108 24.1242 21.3306 24.0109 21.3444C23.8975 21.3581 23.8172 21.4608 23.8313 21.5736Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5246 18.5483L21.9459 18.07L23.0478 17.6296L21.8768 17.7819L19.5246 18.5483Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7478 21.5301C22.7395 21.6466 22.8292 21.7491 22.9482 21.7592C23.0672 21.7693 23.1705 21.6831 23.1788 21.5667C23.1871 21.4503 23.0974 21.3478 22.9783 21.3377C22.8593 21.3276 22.7561 21.4137 22.7478 21.5301Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3922 17.3986L21.8484 17.5746L23.0251 17.6014L21.858 17.4974L19.3922 17.3986Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7283 21.2006C21.6891 21.3082 21.7459 21.4277 21.8551 21.4675C21.9644 21.5074 22.0847 21.4524 22.1239 21.3448C22.1632 21.2372 22.1064 21.1177 21.9971 21.0778C21.8879 21.038 21.7675 21.093 21.7283 21.2006Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5184 16.4639L21.8871 17.2259L23.0553 17.3584L21.9416 16.9139L19.5184 16.4639Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8345 20.6138C20.7644 20.7025 20.7799 20.8308 20.8692 20.9003C20.9584 20.9698 21.0876 20.9542 21.1577 20.8654C21.2278 20.7767 21.2123 20.6484 21.1231 20.5789C21.0338 20.5094 20.9047 20.525 20.8345 20.6138Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9388 15.4583L22.0045 16.8045L23.0927 17.2668L22.1461 16.5623L19.9388 15.4583Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1146 19.8213C20.0229 19.8887 20.0034 20.017 20.071 20.1078C20.1387 20.1987 20.2679 20.2176 20.3596 20.1502C20.4513 20.0828 20.4708 19.9546 20.4031 19.8637C20.3355 19.7729 20.2063 19.7539 20.1146 19.8213Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5947 14.6105L22.2335 16.4427L23.165 17.1723L22.4382 16.2491L20.5947 14.6105Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6259 18.8703C19.5186 18.9116 19.4649 19.0311 19.506 19.1373C19.5471 19.2435 19.6675 19.2961 19.7749 19.2548C19.8822 19.2135 19.9359 19.094 19.8948 18.9878C19.8536 18.8817 19.7333 18.8291 19.6259 18.8703Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4505 13.9604L22.5461 16.1534L23.2582 17.0992L22.804 16.02L21.4505 13.9604Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4025 17.8253C19.2861 17.8372 19.2008 17.9399 19.212 18.0545C19.2231 18.1692 19.3264 18.2524 19.4428 18.2404C19.5591 18.2285 19.6444 18.1258 19.6333 18.0112C19.6222 17.8965 19.5188 17.8133 19.4025 17.8253Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4542 13.5518L22.9128 15.956L23.3597 17.0533L23.2224 15.8915L22.4542 13.5518Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.453 16.767C19.3424 16.7506 19.239 16.8268 19.222 16.9372C19.205 17.0475 19.281 17.1502 19.3916 17.1665C19.5022 17.1828 19.6057 17.1066 19.6226 16.9963C19.6396 16.886 19.5636 16.7833 19.453 16.767Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.602 13.4262L23.4248 15.8538L23.3978 17.0238L23.5026 15.8728L23.602 13.4262Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7825 15.751C19.6794 15.7063 19.559 15.7535 19.5136 15.8563C19.4683 15.9591 19.5151 16.0786 19.6182 16.1233C19.7213 16.1679 19.8417 16.1208 19.8871 16.018C19.9325 15.9151 19.8857 15.7956 19.7825 15.751Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5673 13.556L23.7914 15.8857L23.6184 17.049L24.0576 15.9587L24.5673 13.556Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3658 14.8543C20.2774 14.7843 20.1482 14.7989 20.0772 14.8871C20.0063 14.9753 20.0205 15.1035 20.1089 15.1736C20.1974 15.2437 20.3265 15.229 20.3975 15.1408C20.4684 15.0527 20.4542 14.9244 20.3658 14.8543Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5596 13.9653L24.2025 16.0134L23.7316 17.0943L24.44 16.1565L25.5596 13.9653Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1639 14.1393C21.097 14.0478 20.9678 14.0279 20.8754 14.0947C20.7829 14.1615 20.7622 14.2898 20.8291 14.3812C20.896 14.4726 21.0251 14.4926 21.1176 14.4258C21.2101 14.3589 21.2308 14.2307 21.1639 14.1393Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4128 14.6169L24.5666 16.2403L23.8273 17.1658L24.7561 16.4468L26.4128 14.6169Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1158 13.6487C22.072 13.5446 21.9516 13.4955 21.8469 13.5389C21.7423 13.5823 21.693 13.7018 21.7369 13.8058C21.7807 13.9099 21.9011 13.959 22.0058 13.9156C22.1104 13.8722 22.1597 13.7527 22.1158 13.6487Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0612 15.4583L24.854 16.5622L23.9074 17.2667L24.9956 16.8046L27.0612 15.4583Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1688 13.4266C23.1547 13.3137 23.0513 13.2334 22.9379 13.2471C22.8245 13.2608 22.7441 13.3635 22.7582 13.4763C22.7724 13.5892 22.8757 13.6695 22.9891 13.6558C23.1025 13.642 23.183 13.5394 23.1688 13.4266Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4754 16.452L25.0542 16.9298L23.9521 17.3702L25.1231 17.2182L27.4754 16.452Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2519 13.4703C24.2605 13.3541 24.1712 13.2516 24.0525 13.2412C23.9337 13.2309 23.8305 13.3166 23.8219 13.4328C23.8133 13.5489 23.9025 13.6515 24.0213 13.6618C24.14 13.6722 24.2433 13.5864 24.2519 13.4703Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6063 17.6082L25.1539 17.4298L23.9766 17.3917L25.1411 17.4933L27.6063 17.6082Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2725 13.7991C25.3114 13.6913 25.2541 13.5718 25.1446 13.5321C25.035 13.4925 24.9147 13.5477 24.8758 13.6555C24.8368 13.7633 24.8941 13.8828 25.0037 13.9225C25.1132 13.9621 25.2336 13.9069 25.2725 13.7991Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4837 18.5328L25.1103 17.772L23.9429 17.6448L25.0598 18.0906L27.4837 18.5328Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1698 14.3823C26.2375 14.2913 26.2181 14.1631 26.1265 14.0958C26.0349 14.0285 25.9057 14.0476 25.838 14.1386C25.7702 14.2295 25.7896 14.3577 25.8812 14.425C25.9728 14.4923 26.102 14.4732 26.1698 14.3823Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0649 19.5367L24.9906 18.1922L23.9037 17.7383L24.8563 18.4446L27.0649 19.5367Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8906 15.1741C26.9794 15.1041 26.9943 14.9759 26.9238 14.8876C26.8533 14.7993 26.7241 14.7844 26.6352 14.8544C26.5464 14.9243 26.5315 15.0526 26.602 15.1409C26.6726 15.2291 26.8017 15.244 26.8906 15.1741Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4113 20.3843L24.7584 18.554L23.8291 17.8331L24.5657 18.7581L26.4113 20.3843Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3804 16.1241C27.484 16.08 27.5319 15.9605 27.4872 15.8574C27.4425 15.7542 27.3222 15.7064 27.2185 15.7506C27.1148 15.7948 27.067 15.9142 27.1117 16.0173C27.1564 16.1205 27.2767 16.1683 27.3804 16.1241Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5596 21.0344L24.4398 18.8433L23.7314 17.906L24.2025 18.987L25.5596 21.0344Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6065 17.168C27.7181 17.1522 27.7956 17.0496 27.7796 16.9387C27.7636 16.8278 27.6602 16.7506 27.5487 16.7663C27.4371 16.782 27.3596 16.8847 27.3756 16.9956C27.3916 17.1065 27.495 17.1837 27.6065 17.168Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5683 21.443L24.0567 19.0407L23.6178 17.9519L23.7921 19.1155L24.5683 21.443Z",
    fill: "#000088"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_73_304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 35,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/India.99466b058e7ab9919b947deee8922a49.svg";
export { ForwardRef as ReactComponent };